import React from 'react';
import {useSelector} from 'react-redux';
import {getMediaPath} from 'app/functions';
import DynamicLink from 'components/dynamic_link';
import './index.scss';

const ImageBanner = ({data, onBannerClick}) => {
    const deviceState = useSelector((store) => store.state.deviceState);
    const isMobile = (deviceState === 'mobile');

    const linkData = data['Link']['Link'];
    const imagePath = isMobile
        ? getMediaPath(data['mobile_image'])
        : getMediaPath(data['image']);

    const handleBannerClick = () => {
        onBannerClick?.(data)
    };

    return (
        <div className="top-slider-image-banner">
            {linkData && linkData['route'] === '' && (
                <img src={imagePath} alt={data['title']} className="image-element"/>
            )}

            {linkData && linkData['route'] !== '' && (
                <DynamicLink data={linkData} onClick={handleBannerClick}>
                    <img src={imagePath} alt={data['title']} className="image-element"/>
                </DynamicLink>
            )}
        </div>
    );
};

export default ImageBanner;
